import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { queryKeys } from './queryKeys';

interface Params {
  clientId: string;
  goalId: string;
  deleteEstatePlanningDocuments?: boolean;
}

const deleteGoal = (params: Params) => {
  return authFetch('/Consumer/GoalUpdate/Delete', {
    method: 'POST',
    ...httpBodyOptions(params),
  });
};

interface MutationParams {
  clientId: string;
}

export const useDeleteGoalMutation = ({ clientId }: MutationParams) => {
  const queryClient = useQueryClient();

  return useMutation(deleteGoal, {
    async onSuccess() {
      await queryClient.invalidateQueries(queryKeys.goals(clientId));
    },
  });
};
